import React, { forwardRef, Ref, SVGAttributes } from 'react';

const MicrosoftCalendar = forwardRef(
  (props: SVGAttributes<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
      ref={ref}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.9989 16.8661C32.0006 16.6139 31.8713 16.3792 31.658 16.2473H31.6543L31.6409 16.2398L20.5526 9.62485C20.5047 9.59225 20.455 9.56245 20.4037 9.53561C19.9756 9.313 19.467 9.313 19.0389 9.53561C18.9876 9.56246 18.9379 9.59225 18.8901 9.62485L7.80176 16.2398L7.78838 16.2473C7.44948 16.4597 7.34559 16.9088 7.55633 17.2503C7.61842 17.3509 7.70395 17.4348 7.80548 17.4946L18.8938 24.1095C18.9419 24.1418 18.9915 24.1716 19.0427 24.1988C19.4708 24.4214 19.9793 24.4214 20.4075 24.1988C20.4586 24.1716 20.5083 24.1419 20.5563 24.1095L31.6447 17.4946C31.8662 17.3644 32.0014 17.1245 31.9989 16.8661Z"
        fill="#0A2767"
      />
      <path
        d="M9.09526 12.4494H16.3719V19.1716H9.09526V12.4494ZM30.5114 5.6162V2.5412C30.5289 1.77238 29.9251 1.13463 29.1622 1.11621H10.2793C9.51641 1.13463 8.91258 1.77238 8.93006 2.5412V5.6162L20.0928 8.61618L30.5114 5.6162Z"
        fill="#0364B8"
      />
      <path d="M8.92969 5.61597H16.3716V12.3659H8.92969V5.61597Z" fill="#0078D4" />
      <path
        d="M23.8129 5.61597H16.3711V12.3659L23.8129 19.1159H30.5106V12.3659L23.8129 5.61597Z"
        fill="#28A8EA"
      />
      <path d="M16.3711 12.3665H23.8129V19.1164H16.3711V12.3665Z" fill="#0078D4" />
      <path d="M16.3711 19.116H23.8129V25.8659H16.3711V19.116Z" fill="#0364B8" />
      <path d="M9.09473 19.1721H16.3714V25.2831H9.09473V19.1721Z" fill="#14447D" />
      <path d="M23.8135 19.116H30.5111V25.8659H23.8135V19.116Z" fill="#0078D4" />
      <path
        d="M31.6587 17.4535L31.6446 17.461L20.5562 23.7459C20.5078 23.7759 20.4587 23.8044 20.4073 23.8299C20.219 23.9203 20.0145 23.9713 19.806 23.9799L19.2003 23.6229C19.1491 23.597 19.0994 23.5682 19.0514 23.5367L7.81424 17.0732H7.80903L7.44141 16.8662V29.5891C7.44714 30.438 8.13438 31.1215 8.97665 31.1161H30.4881C30.5007 31.1161 30.5119 31.1101 30.5253 31.1101C30.7032 31.0987 30.8786 31.0618 31.0462 31.0006C31.1186 30.9697 31.1886 30.9331 31.2553 30.8911C31.3052 30.8626 31.3908 30.8004 31.3908 30.8004C31.772 30.5161 31.9976 30.0671 31.9995 29.5892V16.8662C31.9993 17.1096 31.869 17.3339 31.6587 17.4535Z"
        fill="url(#paint0_linear_3907_433502)"
      />
      <path
        opacity="0.5"
        d="M31.4042 16.8162V17.5962L19.8098 25.6414L7.8061 17.0787C7.8061 17.0746 7.80276 17.0712 7.79865 17.0712L6.69727 16.4037V15.8412L7.15122 15.8337L8.11121 16.3887L8.13353 16.3962L8.21539 16.4487C8.21539 16.4487 19.4972 22.9362 19.527 22.9512L19.9586 23.2062C19.9958 23.1912 20.033 23.1762 20.0777 23.1612C20.1 23.1462 31.2777 16.8087 31.2777 16.8087L31.4042 16.8162Z"
        fill="#0A2767"
      />
      <path
        d="M31.6587 17.4535L31.6445 17.4617L20.5562 23.7467C20.5078 23.7767 20.4587 23.8052 20.4073 23.8307C19.9767 24.0427 19.4731 24.0427 19.0425 23.8307C18.9915 23.8052 18.9418 23.7772 18.8936 23.7467L7.80531 17.4617L7.79192 17.4535C7.57784 17.3365 7.44363 17.1116 7.44141 16.8662V29.5892C7.44674 30.4379 8.13373 31.1215 8.97585 31.1162C8.97587 31.1162 8.97588 31.1162 8.97592 31.1162H30.465C31.3071 31.1216 31.9942 30.4379 31.9995 29.5892C31.9995 29.5892 31.9995 29.5892 31.9995 29.5892V16.8662C31.9992 17.1096 31.869 17.3339 31.6587 17.4535Z"
        fill="#1490DF"
      />
      <path
        opacity="0.1"
        d="M20.7181 23.6541L20.5521 23.7478C20.504 23.7787 20.4543 23.807 20.4033 23.8326C20.2204 23.923 20.0216 23.976 19.8184 23.9885L24.0371 29.0165L31.3964 30.8038C31.5981 30.6503 31.7585 30.4484 31.863 30.2165L20.7181 23.6541Z"
        fill="black"
      />
      <path
        opacity="0.05"
        d="M21.4697 23.228L20.5521 23.7478C20.504 23.7786 20.4543 23.8069 20.4033 23.8325C20.2204 23.923 20.0216 23.976 19.8184 23.9885L21.7949 29.4807L31.3986 30.8015C31.777 30.5152 31.9997 30.0663 31.9999 29.5895V29.4252L21.4697 23.228Z"
        fill="black"
      />
      <path
        d="M8.99675 31.1162H30.4628C30.7931 31.1179 31.1152 31.0128 31.3818 30.8162L19.1995 23.6245C19.1483 23.5986 19.0986 23.5698 19.0507 23.5382L7.81349 17.0747H7.80828L7.44141 16.8662V29.5457C7.44057 30.4123 8.13692 31.1154 8.99675 31.1162C8.99673 31.1162 8.99673 31.1162 8.99675 31.1162Z"
        fill="#28A8EA"
      />
      <path
        opacity="0.1"
        d="M17.86 8.49046V24.4879C17.8587 25.0488 17.5203 25.553 17.0042 25.7629C16.8443 25.8322 16.6721 25.8679 16.4981 25.8679H7.44141V7.86571H8.92978V7.11572H16.4982C17.25 7.11859 17.8584 7.73278 17.86 8.49046Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M17.1159 9.24053V25.238C17.1177 25.4191 17.0796 25.5985 17.0042 25.763C16.7976 26.2763 16.3037 26.6132 15.754 26.6157H7.44141V7.86579H15.754C15.9699 7.8636 16.1827 7.91788 16.3717 8.02329C16.8279 8.25492 17.1157 8.72573 17.1159 9.24053Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M17.1158 9.24053V23.738C17.1122 24.4954 16.5054 25.1092 15.754 25.1158H7.44141V7.86579H15.754C15.9699 7.8636 16.1827 7.91788 16.3716 8.02329C16.8278 8.25492 17.1157 8.72573 17.1158 9.24053Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M16.3717 9.24046V23.7379C16.3709 24.4964 15.7624 25.112 15.0098 25.1157H7.44141V7.86572H15.0098C15.7624 7.86613 16.3721 8.4813 16.3717 9.23972C16.3717 9.23997 16.3717 9.24022 16.3717 9.24046Z"
        fill="black"
      />
      <path
        d="M1.36409 7.86572H15.008C15.7614 7.86572 16.3721 8.48123 16.3721 9.24046V22.9909C16.3721 23.7502 15.7614 24.3657 15.008 24.3657H1.36409C0.610717 24.3657 0 23.7502 0 22.9909V9.24046C0 8.48123 0.610735 7.86572 1.36409 7.86572Z"
        fill="url(#paint1_linear_3907_433502)"
      />
      <path
        d="M4.26242 13.6322C4.59862 12.9103 5.14129 12.3062 5.82075 11.8975C6.57322 11.4633 7.42996 11.2469 8.29666 11.272C9.09995 11.2544 9.89259 11.4596 10.588 11.8652C11.2419 12.2582 11.7685 12.834 12.1039 13.5227C12.4692 14.2816 12.6513 15.1169 12.6353 15.9602C12.653 16.8416 12.4656 17.7149 12.0883 18.5102C11.7448 19.2236 11.2015 19.8199 10.5255 20.2254C9.80327 20.6435 8.9812 20.8541 8.14857 20.8344C7.32813 20.8544 6.51801 20.6468 5.80662 20.2344C5.14711 19.841 4.6139 19.2645 4.27062 18.5739C3.90313 17.826 3.7189 17.0002 3.73332 16.1657C3.71801 15.2918 3.89889 14.4258 4.26242 13.6322ZM5.92344 17.7047C6.10269 18.1611 6.40667 18.5569 6.80009 18.8462C7.20081 19.1285 7.68065 19.2741 8.16939 19.2617C8.68987 19.2824 9.20292 19.1319 9.63097 18.8327C10.0194 18.5443 10.3154 18.1474 10.4823 17.6912C10.6689 17.1817 10.761 16.642 10.7539 16.099C10.7597 15.5507 10.6732 15.0055 10.4979 14.4865C10.3432 14.0179 10.0567 13.6046 9.67339 13.297C9.25606 12.9836 8.7444 12.8247 8.22445 12.847C7.72513 12.8339 7.23454 12.9807 6.82316 13.2662C6.42308 13.5568 6.11334 13.9561 5.93014 14.4175C5.52373 15.4751 5.52162 16.6471 5.92418 17.7062L5.92344 17.7047Z"
        fill="white"
      />
      <path d="M23.8135 5.61597H30.5111V12.3659H23.8135V5.61597Z" fill="#50D9FF" />
      <defs>
        <linearGradient
          id="paint0_linear_3907_433502"
          x1="19.7205"
          y1="16.8662"
          x2="19.7205"
          y2="31.1162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35B8F1" />
          <stop offset="1" stopColor="#28A8EA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3907_433502"
          x1="2.84417"
          y1="6.79153"
          x2="13.6531"
          y2="25.3671"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1784D9" />
          <stop offset="0.5" stopColor="#107AD5" />
          <stop offset="1" stopColor="#0A63C9" />
        </linearGradient>
      </defs>
    </svg>
  ),
);

export default MicrosoftCalendar;
